export function pct(n: number): string {
  return `${Math.round((Number.isFinite(n) ? n : 0) * 100)}%`;
}

export function score(n: number): string {
  return Math.round((Number.isFinite(n) ? n : 0) * 100).toString();
}
